import React from "react";
import "./OverlaySpinner.css";

const OverlaySpinner: React.FC<{ message?: string }> = ({ message }) => (
    <div className="Teamsdashboard-overlay">
      <div className="Filter-spinner" />
      {message && <p style={{ marginTop: "12px" }}>{message}</p>}
    </div>
  );  

export default OverlaySpinner;
